import React, { useState, useEffect } from 'react';
import { baseUrl, apiUrl } from '../../../config/apiConfig';
import axios from 'axios';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import CustomHead from '../../../components/common/head/Head';
import Custom404 from '../../_error';

const HeroArea = dynamic(
  () => import('../../../components/pages/product/HeroArea'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const FeatureAreaNew = dynamic(
  () => import('../../../components/pages/product/FeatureAreaNew'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const BestFeaturesArea = dynamic(
  () => import('../../../components/pages/product/BestFeaturesArea'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const AppDetailsArea = dynamic(
  () => import('../../../components/pages/product/AppDetailsArea'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const ModulesArea = dynamic(
  () => import('../../../components/pages/product/ModulesAreaNew'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const PricingArea = dynamic(
  () => import('../../../components/pages/product/PricingArea'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const CtaArea = dynamic(
  () => import('../../../components/pages/product/CtaArea'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const PopularProductsArea = dynamic(
  () => import('../../../components/pages/product/PopularProductsArea'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const ProductImagesArea = dynamic(
  () => import('../../../components/pages/product/ProductImagesArea'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const TechnologyAreaNew = dynamic(
  () => import('../../../components/pages/product/TechnologyAreaNew'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const ProductDemostrationArea = dynamic(
  () => import('../../../components/pages/product/ProductDemostrationArea'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const FaqArea = dynamic(
  () => import('../../../components/pages/product/FaqArea'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const ProductInfo = dynamic(
  () => import('../../../components/pages/product/ProductInfo'),
  {
    loading: () => {
      return '';
    },
    ssr: false,
  }
);
const ProductPage = ({ productDetails, siteSetting }) => {
  // console.log(productDetails);

  const router = useRouter();
  const [productInfo, setproductInfo] = useState(null);
  const [productAdvanceFeatures, setproductAdvanceFeatures] = useState([]);
  const [productFeatures, setproductFeatures] = useState([]);
  const [productModules, setproductModules] = useState([]);
  const [productPricings, setproductPricings] = useState([]);
  const [productShowCase, setproductShowCase] = useState([]);
  const [popularProducts, setpopularProducts] = useState([]);
  const [productDemonstrations, setproductDemonstrations] = useState([]);
  const [productFaqs, setproductFaqs] = useState([]);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (productDetails) {
        setproductInfo(productDetails.productInfo);
        setproductAdvanceFeatures(productDetails.productAdvanceFeatures);
        setproductFeatures(productDetails.product_feature);
        setproductModules(productDetails.product_modules);
        setproductPricings(productDetails.product_pricings);
        setproductShowCase(productDetails.product_showcases);
        setpopularProducts(productDetails.popularProducts);
        setproductDemonstrations(productDetails.product_demonstrations);
        setproductFaqs(productDetails.product_faqs);
      }
    }
    return () => {
      mounted = false;
    };
  }, [router, productDetails]);

  if (!productDetails) {
    return <Custom404 />;
  }

  return (
    <>
      <CustomHead
        title={
          (productDetails.productInfo &&
          productDetails.productInfo.product_custom_title
            ? productDetails.productInfo.product_custom_title
            : productDetails.productInfo.product_name) +
          ' | ' +
          (siteSetting && siteSetting.title ? siteSetting.title : metaSiteTitle)
        }
        metaTitle={
          productDetails.productInfo && productDetails.productInfo.product_name
            ? productDetails.productInfo.product_name
            : 'Product Details'
        }
        description={
          productDetails.productInfo && productDetails.productInfo.product_des
            ? productDetails.productInfo.product_des
            : ''
        }
        url={
          productDetails.productInfo && productDetails.productInfo.slug
            ? baseUrl + '/product/' + productDetails.productInfo.slug
            : ''
        }
        image={
          productDetails.productInfo && productDetails.productInfo.image
            ? apiUrl + productDetails.productInfo.image
            : ''
        }
        type={'article'}
      />
      <div className="page-area product-software-area mh-80v">
        <HeroArea productInfo={productInfo} />
        {/* <FeatureArea
        productAdvanceFeatures={productAdvanceFeatures}
        productInfo={productInfo}
      /> */}

        {productInfo && productInfo.advance_feature_status == 1 && (
          <FeatureAreaNew
            productAdvanceFeatures={productAdvanceFeatures}
            productInfo={productInfo}
          />
        )}

        {productInfo && productInfo.showcase_status == 1 && (
          <ProductImagesArea productImages={productShowCase} />
        )}

        {productInfo && productInfo.technology_status == 1 && (
          <TechnologyAreaNew technologyInfo={productDetails.technologyData} />
        )}
        {productInfo && productInfo.featured_status == 1 && (
          <BestFeaturesArea
            productFeatures={productFeatures}
            productInfo={productInfo}
          />
        )}
        <AppDetailsArea productInfo={productInfo} />
        {productInfo && productInfo.module_status == 1 && (
          <ModulesArea
            productModules={productModules}
            productInfo={productInfo}
          />
        )}

        {productInfo && productInfo.demonstration_status == 1 && (
          <ProductDemostrationArea
            productDemonstrations={productDemonstrations}
            productInfo={productInfo}
          />
        )}

        {productInfo && productInfo.faq_section_status == 1 && (
          <FaqArea productFaqs={productFaqs} />
        )}

        {productInfo && productInfo.pricing_status == 1 && (
          <PricingArea productPricings={productPricings} />
        )}
        <CtaArea />
        {productInfo && productInfo.product_info && (
          <ProductInfo productInfo={productInfo} />
        )}
        <PopularProductsArea popularProductsData={popularProducts} />
      </div>
    </>
  );
};

export async function getServerSideProps(params) {
  try {
    const productDetails = await axios
      .get(apiUrl + '/api/productDetail?slug=' + params.query.slug)
      .then((response) => {
        // console.log(response.data.data);
        return response.data.data;
      })
      .catch((error) => {
        return null;
      });

    const siteSetting = await axios
      .get(apiUrl + '/api/siteSetting')
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        return null;
      });

    return {
      props: {
        productDetails: productDetails,
        siteSetting: siteSetting,
        loaded: true,
      },
    };
  } catch (error) {
    return {
      props: {
        productDetails: null,
        siteSetting: null,
        loaded: true,
      },
    };
  }
}

export default ProductPage;
